<template>
  <v-icon :style="rotation" v-if="directionIcon">
    mdi-arrow-up-bold
  </v-icon>
</template>

<script>
export default {
  name: "TrendIndicator",
  props: {
    trend: {
      type: String,
    },
  },
  computed: {
    directionIcon() {
      // TODO make this just a boolean if we don't get better icons
      if (this.trend === "Lowered" || this.trend === "Decreased") {
        return "mdi-arrow-down-bold";
      }
      if (this.trend === "Raised" || this.trend === "Increased") {
        return "mdi-arrow-up-bold";
      }
      return null;
    },
    rotation() {
      if (this.trend === "Lowered" || this.trend === "Decreased") {
        return "transform: rotate(135deg)";
      }
      if (this.trend === "Raised" || this.trend === "Increased") {
        return "transform: rotate(45deg)";
      }
      return null;
    },
  },
};
</script>

<style scoped></style>
